export interface GroupByOption<TKey extends string> {
    key: TKey;
    label: string;
    /**
     * Trigger text override. The default `By ${label.toLowerCase()}` reads
     * badly for labels that already contain "by" ("By connected by").
     */
    triggerLabel?: string;
}

export const groupByTriggerLabel = <TKey extends string>({
    value,
    options,
}: {
    value: TKey;
    options: Array<GroupByOption<TKey>>;
}): string => {
    const selected = options.find((option) => option.key === value);
    if (selected?.triggerLabel) {
        return selected.triggerLabel;
    }
    return `By ${(selected?.label ?? value).toLowerCase()}`;
};
